import { render, staticRenderFns } from "./WarehouseDataTable.vue?vue&type=template&id=59e8d130&"
import script from "./WarehouseDataTable.vue?vue&type=script&lang=js&"
export * from "./WarehouseDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VPagination,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e8d130')) {
      api.createRecord('59e8d130', component.options)
    } else {
      api.reload('59e8d130', component.options)
    }
    module.hot.accept("./WarehouseDataTable.vue?vue&type=template&id=59e8d130&", function () {
      api.rerender('59e8d130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Warehouse/components/Warehouse/WarehouseDataTable.vue"
export default component.exports